import { ChainId } from '@nominex/nomiswap-sdk'
import type {
  UnknownAsyncThunkFulfilledAction,
  UnknownAsyncThunkPendingAction,
  UnknownAsyncThunkRejectedAction,
} from '@reduxjs/toolkit/dist/matchers'
import indexBy from 'ramda/es/indexBy'
import map from 'ramda/es/map'
import mergeDeepRight from 'ramda/es/mergeDeepRight'
import mergeWith from 'ramda/es/mergeWith'
import pipe from 'ramda/es/pipe'
import prop from 'ramda/es/prop'
import reduce from 'ramda/es/reduce'
import values from 'ramda/es/values'
import { bonusesApi } from 'restApi'

export const mergeFarmsByPid = (data) =>
  pipe(map(indexBy(prop('pid'))), reduce(mergeWith(mergeDeepRight), {}), values)(data)

function joinKey(type: string, farms: [], pids: [], chainId: ChainId): string {
  return [type, farms?.length ?? 0, pids?.length ?? 0, chainId].join('/')
}

export const serializeActionToKey = (
  action: UnknownAsyncThunkFulfilledAction | UnknownAsyncThunkPendingAction | UnknownAsyncThunkRejectedAction,
) => {
  const [type] = action.type.split(`/${action.meta.requestStatus}`)
  const { farms, pids, chainId } = action.meta.arg as any

  return joinKey(type, farms, pids, chainId)
}

export const serializeConditionArgsToKey = (type: string, arg: any): string => {
  const { farms, pids, chainId } = arg

  return joinKey(type, farms, pids, chainId)
}

export const fetchHolderBonusPools = async () => {
  // API endpoint no longer available - returning empty array
  return []
}
